import { CustomAction } from "..";
import { AUTH_ACTION_TYPES } from "../actions-types";
import { AuthType } from "../../types/auth";

export const actionSetAuthType = (data: AuthType): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_TYPE,
    data,
  };
};

export const actionSetAuthLoggedIn = (data: boolean): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_LOGGED_IN,
    data,
  };
};

export const actionSetAuthLoading = (data: boolean): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_LOADING,
    data,
  };
};

export const actionSetAuthSessionToken = (data: string): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_SESSION_TOKEN,
    data,
  };
};

export const actionSetAuthEmailBanDuration = (data: string): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_EMAIL_BAN_DURATION,
    data,
  };
};

export const actionResetAuth = (): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.RESET_AUTH,
  };
};
